import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import ProfilePhoto from '../../../../styles/images/profile-photo.png';
import MenuItems from './menu_item';
import { handleChangeDataBottomSheet } from '../../../../redux/actions/partials/footer/bottom_sheet';
import CloseIcon from '../../../../styles/images/close.png';

const Profile = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleBackBtn = () => {
        navigate('/', { replace: true });
    };

    const { profile } = useSelector(state => state.user);

    const closeBottomSheet = () => {
        dispatch(handleChangeDataBottomSheet('isOpen', false));
    };

    return (

        <div id="profile-page" onClick={closeBottomSheet} >

            <div className="d-flex justify-content-end py-4 white-bg sticky top-0 z-index-2">
                <img src={CloseIcon} alt="back" onClick={handleBackBtn} role="button" />
            </div>


            <div className="d-flex justify-content-start short-profile  p-4">
                <img src={ProfilePhoto} width={60} className="mr-4" alt="پروفایل" />
                <div className="d-flex flex-column justify-content-center">
                    <span>{profile.fname !== null ? profile.fname : ""}  {profile.lname !== null ? profile.lname : ""}</span>
                    <span className="mt-1 phone-num">{profile.mobile}</span>
                </div>
            </div>

            

            <MenuItems />
        </div>

    );
}

export default Profile;